import { useParams } from "react-router-dom";
import { canUsePermission } from "../../../lib/auth";
import { useCurrentAuthUser } from "../../auth";
import { ITINERARY_PERMISSIONS } from "../permissions";
import { ItineraryTableFeaturePage } from "../ui/ItineraryTableFeaturePage";

/** 独立行程表格入口，切换行程或账号时重建请求状态。 */
export function ItineraryTablePage() {
  const { itineraryId = "" } = useParams();
  const auth = useCurrentAuthUser();
  if (!auth.isSuccess) return null;
  return <ItineraryTableFeaturePage key={`${auth.data.id}:${itineraryId}`} itineraryId={itineraryId} canShare={canUsePermission(auth.data, ITINERARY_PERMISSIONS.share)} />;
}
